import gql from 'graphql-tag';

export function listLoadSheetWorkflowsQuery() {
  return gql(`
    query ListLoadSheetWorkflows($loadId: Int!, $mobileUserConfigId: Int!) {
      loadSheetWorkflows: listLoadSheetWorkflows(loadId: $loadId, mobileUserConfigId: $mobileUserConfigId) {
        id
        form
        formId
        processDefinitionId
        processInstanceId
        formKey
        category
        createTime
        name
        priority
        taskDefinitionKey
        variables {
          name
          value
        }
      }
      availablePickCount: availablePickCountForLoad(loadId: $loadId)
    }
  `);
}
